// extracted by css-extract-rspack-plugin
export default {"blockText":"s6QUY5ocEFURxwW6"};